import PageContent from "@/components/PageContent";
import PageHeader from "@/components/PageHeader";
import Title from "@/components/Title";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { PATH_PASSWORD_CHANGE, PATH_ROOT } from "@/constants";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import LanguageSelect from "./components/LanguageSelect";
import SignedInUser from "./components/SignedInUser";

export default function UserProfile() {
  const { t, i18n } = useTranslation();

  const onLanguageChange = (language: string) => {
    i18n.changeLanguage(language);
  };

  const breadcrumbItems = useMemo(
    () => [
      { label: t("breadcrumb.home"), href: PATH_ROOT },
      { label: t("userProfile.title") },
    ],
    [t],
  );

  const labelWrapperClassName =
    "grid grid-cols-1 sm:grid-cols-[150px_1fr] items-center gap-4 py-4";
  const labelClassName = "sm:text-right text-left";

  return (
    <>
      <PageHeader breadcrumbItems={breadcrumbItems} />
      <PageContent title={t("userProfile.title")}>
        <div className="grid gap-4 py-4">
          <Label className={labelWrapperClassName}>
            <span className={labelClassName + " self-start"}>
              {t("userProfile.signedInAs")}
            </span>
            <SignedInUser />
          </Label>
        </div>

        <Title className="mt-8">{t("userProfile.settingsTitle")}</Title>
        <div className="grid gap-4 py-4">
          <Label className={labelWrapperClassName}>
            <span className={labelClassName}>
              {t("userProfile.settings.language")}
            </span>
            <LanguageSelect onLanguageChange={onLanguageChange} />
          </Label>
          <Label className={labelWrapperClassName}>
            <span className={labelClassName}>
              {t("userProfile.settings.password")}
            </span>
            <Button asChild variant="secondary" className="w-fit">
              <Link to={PATH_PASSWORD_CHANGE}>
                {t("userProfile.settings.changePassword")}
              </Link>
            </Button>
          </Label>
        </div>
      </PageContent>
    </>
  );
}
